import { AUTH_ROUTES } from "../constants/allRoutePaths";

export const getSignInLandingUrl = () => {
  return process.env.REACT_APP_SIGNIN_LANDING_URL;
};

export const goToSignInLanding = (navigate) => {
  const signInLandingUrl = getSignInLandingUrl();

  if (!signInLandingUrl) {
    return;
  }

  const isExternalUrl = /^https?:\/\//i.test(signInLandingUrl);

  if (isExternalUrl) {
    window.location.href = signInLandingUrl;
    return;
  }

  navigate(signInLandingUrl);
};

export const redirectToSignInLandingIfNotOnAuthPage = () => {
  const path = window.location.pathname;
  const signInLandingUrl = getSignInLandingUrl();

  const isAuthPage =
    path.startsWith(`/${AUTH_ROUTES.SIGNIN_INITIAL_PATIENT}`) ||
    path.startsWith(`/${AUTH_ROUTES.SIGNIN_INITIAL_PROVIDER}`) ||
    path.startsWith(`/${AUTH_ROUTES.SIGNIN_LANDING}`);

  const normalizeUrl = (url) => url.replace(/\/$/, "");

  const isSleepNavigatorPage =
    normalizeUrl(window.location.href) ===
    normalizeUrl(AUTH_ROUTES.SLEEPNAVIGATOR_URL);

  if (!isAuthPage && !isSleepNavigatorPage) {
    window.location.href = signInLandingUrl;
  }
};
